import React from 'react';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const Logo = ({ menuToggled, setMenuToggled, isNavigationVariant, type }) => {

  const LogoClasses = c('Logo', {
    'Logo--active': menuToggled,
    'Logo--variant': isNavigationVariant,
    'Logo--footer': type === 'footer',
  });

  const setToggle = () => {
    if (menuToggled === true) {
      setMenuToggled(false);
    }
  };

  return (
    <div onClick={setToggle}>
      <CoreLink className={LogoClasses} id="Navigation__logo" to="/" title="Homepage" />
    </div>
  );
};

export default Logo;
